import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import WarningSolid from './warning-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <WarningSolid {...validProps} />;
}
SvgComponent.iconName = 'warningSolid';

export const WarningSolidIcon = svgIconWrapper(SvgComponent);
